import type { RouteObject } from "react-router";
import EpisodePipelinePage from "@/src/stories/pages/episode-pipeline-page";

export const storiesRoutes: RouteObject[] = [{ path: "/series/:seriesId/episodes/:id", element: <EpisodePipelinePage /> }];
